import { AppVariants } from "common/types/appVariant";

import { getFeatureFlag } from "features/feature-flags";
import isGoStudentLearningApp from "features/goStudentLearning/utils/isGoStudentLearningApp";
import { isPlurallApp } from "features/plurall";

export const appNames = {
  seneca: "Seneca",
  senecaPrimary: "Seneca",
  plurall: "Adapta",
  goStudentLearning: "GoStudent Learning"
};

export function getAppVersion() {
  return import.meta.env.VITE_APP_VERSION;
}

export function getAppName() {
  const appVariant = getAppVariant();
  return appNames[appVariant];
}

export function getAppVariant() {
  if (isPlurallApp()) return AppVariants.plurall;
  if (isGoStudentLearningApp()) return AppVariants.goStudentLearning;
  if (getFeatureFlag("isPrimaryApp")) return AppVariants.senecaPrimary;

  return AppVariants.seneca;
}
